
export function get_vars_cfg() {
    return  {
  "abboths_client_id": "4d5lgp8fbjeokbjfvjjo88ciuj",
  "repdirecths_client_id": "2per8rq26l2c8841nn2iuvavfu",
  "hstream_client_id": "5hccm0gp6b3f7jvvb5mnn12n22",
  "hstream_hpa_url": "https://login.hstream.com",
  "api_endpoint": "wwm-sn1-snqa-sfy-ind-fastapi-gw.ww.qa.hstream.net",
  "error_page": "https://healhstream-testing.myshopify.com/pages/sad-trombone",
  "store_name": "healhstream-testing",
  "hstream_subdomain": "hstream.com"
}
};
